import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@env/environment';
import { UserService } from '@shared/services/user.service';

/**
 * HTTP interceptor that attaches the JWT Bearer token to outgoing API requests.
 * Skips token injection for public endpoints (login, register, forgot-password, confirm-email).
 * Only applies to requests targeting the configured API endpoint.
 */
export const TokenInterceptor = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
    const url: string = request.url;
    const userService = inject(UserService);

    const isApiRequest = url.startsWith(environment.apiEndpoint) || url.startsWith('/api/');
    if (!isApiRequest) return next(request);

    const isPublicEndpoint =
        url.includes('/Users/login') ||
        url.includes('/Users/forgotPassword') ||
        url.includes('/Users/register') ||
        url.includes('/Users/confirmEmail') ||
        url.includes('/Users/resendConfirmationEmail');

    if (isPublicEndpoint) {
        return next(request);
    }

    request = request.clone({
        setHeaders: {
            Authorization: 'Bearer ' + userService.accessToken(),
        },
    });

    return next(request);
};
